import {mapActions, mapGetters, mapMutations} from "vuex";
import {filtersCustomScheme} from '@/utils/filtersCommon'

import breadcrumbs from '@/components/breadcrumbs/index.vue'
import filters from '@/components/filters/index.vue'
import propertiesGrid from '@/components/properties-grid/index.vue'
import filtersCustom from '@/components/filters-custom/index.vue'

import _ from "lodash";

export default {
  name: 'home',
  //---components
  components: {
    breadcrumbs,
    filters,
    propertiesGrid,
    filtersCustom,
  },
  //---data
  data () {
    return {
      titlesArray: [
        'Real Estate Search Results',
        'New Construction Real Estate Listings',
        'Foreclosure Real Estate Listings',
        'Pending Sales Real Estate Listings',
        'Active Condo Real Estate Listings',
        'Open House Real Estate Listings',
        'Active Real Estate Listings with Virtual Tours',
      ]
    }
  },
  //---hooks
  created: function () {
    let promiseCollection = [];

    let getListingsRequest = this.getListings({filters: this.$route.query, perPage: 12});
    promiseCollection.push(getListingsRequest);

    if (this.filtersScheme === null) {
      let getSchemeFiltersRequest = this.getSchemeFilters();
      promiseCollection.push(getSchemeFiltersRequest);
    }

    if (promiseCollection.length > 0 ) {
      this.loaderFlag(true);
      Promise.all(promiseCollection).finally(()=> {
        this.loaderFlag(false);
      })
    }
  },
  computed: {
    ...mapGetters({
      filtersMeta: 'FILTERS/filtersMeta',
      filtersScheme: 'FILTERS/filtersScheme',
    }),
    getPageTitle: function () {
      let titleId = 0;
      let queryKeys = Object.keys(this.$route.query)

      if (queryKeys.length) {
        queryKeys.forEach(key => {
          let findItem = filtersCustomScheme.find(schemeItem => schemeItem.type === key);
          if (findItem) {
            titleId = findItem.id + 1
          }
        })
      }

      return this.titlesArray[titleId];
    }
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
    }),
    ...mapActions({
      getSchemeFilters: 'FILTERS/FILTERS_SCHEME_REQUEST_GET',
      getListings: 'FILTERS/FILTERS_LISTINGS_REQUEST_GET'
    }),
    filtersChange(filter) {
      this.loaderFlag(true);

      this.$router.push({
        name: 'properties',
        query: filter
      })

      this.getListings({filters: filter, perPage: 12}).finally(()=> {
        this.loaderFlag(false);
      });
    },
  }
}
